// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide[data-v-25103f36]{width:350px}.swiper-button[data-v-25103f36]{position:absolute;top:50%;z-index:1}.swiper-button-next[data-v-25103f36]{right:16px}.swiper-button-prev[data-v-25103f36]{left:16px}@media only screen and (max-width:599.98px){.preview-card[data-v-25103f36]{transform:scale(.85)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
